import { render, staticRenderFns } from "./TagsAutocomplete.vue?vue&type=template&id=249ce518&scoped=true&"
import script from "./TagsAutocomplete.vue?vue&type=script&lang=js&"
export * from "./TagsAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./TagsAutocomplete.vue?vue&type=style&index=0&id=249ce518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249ce518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VChip})
